<template>
  <div
    v-if="entries.length > 0"
    class="flex flex-col gap-4 bg-white border border-[#d8d8e2] rounded-lg p-4 text-left"
  >
    <p class="text-lg font-bold leading-6 text-[#16161d]">Histórico</p>
    <div class="flex flex-col gap-2">
      <div v-for="(entry, index) in entries" :key="index" class="flex gap-2">
        <div class="flex flex-col items-center">
          <div v-if="index === 0" class="w-3 h-3 rounded-full bg-[#2f7f91] shrink-0" />
          <div v-else class="w-3 h-3 flex items-center justify-center shrink-0">
            <div class="w-2 h-2 rounded-full bg-[#16161d]" />
          </div>
          <div v-if="index < entries.length - 1" class="w-px flex-1 bg-[#d8d8e2] my-1" />
        </div>
        <div class="flex flex-col gap-0.5 pb-2">
          <p class="text-sm leading-[18px] text-[#323232]">
            <span class="font-bold">{{ entry.date }}</span>
            {{ entry.action }}
          </p>
          <p class="text-xs leading-[14px] text-[#808080]">
            {{ entry.time }}, por {{ getFirstAndSecondName(entry.performedBy) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FacialBiometryStatus } from '@/constants/facial-biometry.constants'
import type {
  FacialBiometryDoctorItem,
  FacialBiometryHistoryEntry
} from '@/types/facial-biometry.types'
import { formatDateInOffset, formatHourMinuteWithZoneInOffset } from '@/utils/date'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'

const props = defineProps<{
  doctor: FacialBiometryDoctorItem | null
}>()

const entries = computed<FacialBiometryHistoryEntry[]>(() => {
  const doctor = props.doctor
  if (!doctor) return []

  const result: FacialBiometryHistoryEntry[] = []

  if (doctor.reviewedAt && doctor.reviewedBy) {
    const statusAction =
      doctor.status === FacialBiometryStatus.VERIFIED
        ? 'Biometria facial aprovada'
        : 'Biometria facial reprovada'
    result.push({
      action: statusAction,
      date: formatDateInOffset(doctor.reviewedAt) ?? '',
      time: formatHourMinuteWithZoneInOffset(doctor.reviewedAt) ?? '',
      performedBy: doctor.reviewedBy.name
    })
  }

  if (doctor.createdAt) {
    result.push({
      action: 'Biometria facial enviada',
      date: formatDateInOffset(doctor.createdAt) ?? '',
      time: formatHourMinuteWithZoneInOffset(doctor.createdAt) ?? '',
      performedBy: doctor.doctor.name
    })
  }

  return result
})
</script>
